import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = (props: SvgProps) => (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
        <Path
            d="M13 11.9999C13 11.4476 12.5523 10.9999 12 10.9999C11.4477 10.9999 11 11.4476 11 11.9999V15.9999C11 16.5522 11.4477 16.9999 12 16.9999C12.5523 16.9999 13 16.5522 13 15.9999V11.9999Z"
            fill={props.color ?? designSystem.colors.neutral300}
        />
        <Path
            d="M12 9.50012C12.6904 9.50012 13.25 8.94048 13.25 8.25012C13.25 7.55976 12.6904 7.00012 12 7.00012C11.3096 7.00012 10.75 7.55976 10.75 8.25012C10.75 8.94048 11.3096 9.50012 12 9.50012Z"
            fill={props.color ?? designSystem.colors.neutral300}
        />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1.99988C6.47715 1.99988 2 6.47703 2 11.9999C2 17.5227 6.47715 21.9999 12 21.9999C17.5228 21.9999 22 17.5227 22 11.9999C22 6.47703 17.5228 1.99988 12 1.99988ZM4 11.9999C4 7.5816 7.58172 3.99988 12 3.99988C16.4183 3.99988 20 7.5816 20 11.9999C20 16.4182 16.4183 19.9999 12 19.9999C7.58172 19.9999 4 16.4182 4 11.9999Z"
            fill={props.color ?? designSystem.colors.neutral300}
        />
    </Svg>
);
export { SvgComponent as InfoIconCircle };
